import { ScheduledSectionStatus } from '../../course_scheduler/types/scheduled_section_status_enum';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { CalendarTimesModel } from '../models/calendar_times_model';
import { IDefineCommand, IQueryMediator } from 'core-ts-types';
import { CalendarScheduledSectionServant } from '../servants/calendar_scheduled_section_servant';
import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .service(
    'loadStudentUnavailabilityCommand',
    function loadStudentUnavailabilityCommandDefinition(
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      calendarTimeFn: any,
      ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
      ngCalendarTimesModel: CalendarTimesModel,
      ngSectionsDatasource: ISectionsDatasource,
      QueryMediator: IQueryMediator
    ) {
      return defineCommandORM(
        'loadStudentUnavailabilityCommand',
        function loadStudentUnavailabilityCommand(deferred, termId) {
          if (!termId) {
            deferred.resolve();
            return;
          }

          $http
            .get(`reg/preference/term/${termId}/unavailability`)
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              const times = _4.sortBy(calendarTimeFn.importTimes(data.timeslot), (time: any) => time.day.ordinal);
              const unAvailableTimes = ngCalendarScheduledSectionServant.buildUnavailableTimes(times);
              ngCalendarTimesModel.write({
                busy_times: unAvailableTimes,
                loaded_times: true
              });
              return deferred.resolve(times);
            })
            .catch(deferred.reject);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/commands/load_student_unavailability_command.ts